<ng-container *transloco="let t">
  <label [for]="formControlName">{{ label }}<ng-container *ngIf="required">*</ng-container></label>
  <input
    [id]="formControlName"
    [formControl]="getFormControl()"
    class="form-control"
    [placeholder]="placeholder && placeholder"
    [ngClass]="{
      'is-invalid':
        (required || customValidation) &&
        childForm.get(formControlName).invalid &&
        (childForm.get(formControlName).dirty || childForm.get(formControlName).touched)
    }"
    type="text"
    (input)="onInputChange($event)"
  />
  <ng-container *ngIf="required || customValidation">
    <div
      *ngIf="childForm.get(formControlName).invalid && (childForm.get(formControlName).dirty || childForm.get(formControlName).touched)"
      class="invalid-feedback"
    >
      <div *ngIf="required && childForm.get(formControlName).hasError('required')">{{ formControlError }}</div>
      <div *ngIf="customValidation && childForm.get(formControlName).hasError(customErrorName)">
        {{ formControlCustomError }}
      </div>
    </div>
  </ng-container>
</ng-container>
